import { styled } from "@monolith-forensics/monolith-ui";

export const StepIndicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  padding: 16px 0 8px;
`;

export const StepItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StepCircle = styled.div<{ $active: boolean; $completed: boolean }>`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
  transition: all 0.2s ease;

  background: ${(props) =>
    props.$active || props.$completed
      ? props.theme.palette.primary.main
      : props.theme.palette.divider};
  color: ${(props) =>
    props.$active || props.$completed
      ? "#fff"
      : props.theme.palette.text.secondary};
`;

export const StepLabel = styled.span<{ $active: boolean }>`
  font-size: 13px;
  font-weight: ${(props) => (props.$active ? 600 : 400)};
  color: ${(props) =>
    props.$active
      ? props.theme.palette.text.primary
      : props.theme.palette.text.secondary};
  white-space: nowrap;
`;

export const StepConnector = styled.div<{ $completed: boolean }>`
  width: 40px;
  height: 2px;
  margin: 0 8px;
  background: ${(props) =>
    props.$completed
      ? props.theme.palette.primary.main
      : props.theme.palette.divider};
  transition: background 0.2s ease;
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  padding: 16px 0;
  min-height: 300px;
  overflow-y: auto;
  padding-right: 16px;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
`;

export const FooterLeft = styled.div`
  display: flex;
  gap: 8px;
`;

export const FooterRight = styled.div`
  display: flex;
  gap: 8px;
`;

export const FooterCenter = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
